import moment from 'moment';
export function PayrollFinancialsService($http, $q, apexApiUrl) {
    'ngInject';
    return {
        retrievePayrollFinancials: retrievePayrollFinancials,
        retrievePayrollFinancialsProgramSummary: retrievePayrollFinancialsProgramSummary
    };

    function retrievePayrollFinancials(startDate, endDate, divisionID) {
        const params = {};
        if (startDate) {
            params.startDate = moment(startDate).format("YYYY-MM-DD");
        }
        if (endDate) {
            params.endDate = moment(endDate).format("YYYY-MM-DD");
        }
        params.divisionID = divisionID;
        return $http({
            method: "GET",
            url: apexApiUrl + "payrolls/financials",
            params: params,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function retrievePayrollFinancialsProgramSummary(startDate, endDate, programID) {
        const params = {};
        if (startDate) {
            params.startDate = moment(startDate).format("YYYY-MM-DD");
        }
        if (endDate) {
            params.endDate = moment(endDate).format("YYYY-MM-DD");
        }
        params.programID = programID;

        return $http({
            method: "GET",
            url: apexApiUrl + "payrolls/financials-program",
            params: params,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }
}
